import React from 'react';
import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from '@billda/design-system';

interface ResendInviteConfirmDialogProps {
  open: boolean;
  email: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export const ResendInviteConfirmDialog: React.FC<
  ResendInviteConfirmDialogProps
> = ({ open, email, onConfirm, onCancel, isLoading }) => {
  return (
    <Dialog
      open={open}
      onOpenChange={nextOpen => {
        if (!nextOpen) {
          onCancel();
        }
      }}
    >
      <DialogContent aria-labelledby="resend-invite-dialog-title">
        <DialogHeader id="resend-invite-dialog-title">
          Resend Invitation
        </DialogHeader>
        <DialogBody>
          Are you sure you want to resend the invitation to{' '}
          <strong>{email}</strong>? This will create a new invitation with a
          fresh expiration date.
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={onCancel} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="neutral"
            onClick={onConfirm}
            disabled={isLoading}
            loading={isLoading}
            data-testid="confirm-resend-button"
          >
            {isLoading ? 'Sending...' : 'Resend'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
